import React  from 'react';
import DateComponentProto from './date-proto';


export default function renderDateInList(id, props) {
    return <DateComponentProto renderMode="list" id={id} {...props} />;
}